export default {
  ticketMedio: [],
  mediaItens: {},
  horasMaioresCompras: [],
  diasMaioresCompras: [],
  diasSemanaMaioresCompras: [],
  melhoresClientes: [],
  retencao: [],
  retencaoDatas: [],
  listaInteressesGenero: [],
  listaInteressesIdade: [],
  listaInteressesIdadeValor: [],
  perfilDemograficoBairroFisica: [],
  perfilDemograficoBairroJuridica: [],
  perfilDemograficoFaixa: [],
  perfilDemograficoGenero: [],
  quantidadeClientesCadastrados: null,
  quantidadeClientesAtivos: null,
  quantidadeClientesPerdidos: null,
  produtosValidados: {},
  inicioFidelidade: {},
  datasLimites: {},
  clientesNovos: {},
  clientesAtivos: {},
  clientesPerdidos: {},
}
